export const configs = {
    'templates': {
        'articles': require('../templates/articles.hbs'),
        'pagination': require('../templates/pagination.hbs'),
        'filters': require('../templates/filters.hbs'),
        'noresults': require('../templates/noresults.hbs')
    },
    'partials': {
        'normal': require('../templates/article.hbs'),
        'conferenza': require('../templates/conferenza.hbs'),
        'pubblicazione': require('../templates/pubblicazione.hbs')
    },
    'helpers': {

    },
    'noresults': {
        'conferenze': {
            'msg': 'Al momento non ci sono conferenze stampa in programma',
            'back': true
        },
        'ricerca': {
            'msg': 'Non è stato trovato nessun elemento',
            'back': false
        }
    },
    'getLocaleDate': (date, withTime) => {
        try {
            let options = withTime ? { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' } : { year: 'numeric', month: 'short', day: 'numeric' };
            return date.toLocaleDateString('it-IT', options);
        } catch (e) {
            console.error(e);
            return null;
        }
    },
    'getLocale': (date, options = { month: 'short' }) => {
        try {
            //const options = {month: 'short'};
            return date.toLocaleString('it-IT', options);
        } catch (e) {
            console.error(e);
            return null;
        }
    },
    'mapping': {
        'comunicati': [
            {
                'Tutti': {
                    'categories': [
                        'COMUNICATI CDA|Category-01e0d5af-0210-4dac-bdff-3df318cbb4e8',
                        'Comunicati Aziendali|Category-0a9a3c8a-f274-4096-9721-501027395077',
                        'Comunicati Radio tv e digital|Category-5992d6fe-2de2-444a-ad8c-2421ec15f2bb',
                        'Ascolti|Category-970b416a-8d16-4df0-a666-aeb0c8f31340'
                    ],
                    'href': '/ufficiostampa/Comunicati-fa34ec44-48fc-47bb-9b33-a816feb74563.html?tematica=COMUNICATI%20CDA|Category-01e0d5af-0210-4dac-bdff-3df318cbb4e8&tematica=Ascolti|Category-970b416a-8d16-4df0-a666-aeb0c8f31340&tematica=Comunicati%20Radio%20tv%20e%20digital|Category-5992d6fe-2de2-444a-ad8c-2421ec15f2bb&tematica=Comunicati%20Aziendali|Category-0a9a3c8a-f274-4096-9721-501027395077&tipo=Articolo',
                    'label': 'Tutti'
                }
            },
            {
                'Festival di Sanremo': {
                    'categories': ['Festival di Sanremo|Category-850fc4ff-bf81-458f-b6a3-9feafaebcbcd'],
                    'href': '/ufficiostampa/Comunicati-fa34ec44-48fc-47bb-9b33-a816feb74563.html?tematica=Festival%20di%20Sanremo|Category-850fc4ff-bf81-458f-b6a3-9feafaebcbcd&tipo=Articolo',
                    'label': 'Festival di Sanremo'
                }
            },
            {
                "Eurovision Song Contest":
                {
                    'categories': ["Eurovision Song Contest|Category-7fb87f94-c31f-4e57-852a-985da64aee05"],
                    'href': "/ufficiostampa/Comunicati-fa34ec44-48fc-47bb-9b33-a816feb74563.html?tematica=Eurovision%20Song%20Contest|Category-7fb87f94-c31f-4e57-852a-985da64aee05&tipo=Articolo",
                    'label': "Eurovision Song Contest"
                }
            },
            {
                "Prix Italia": 
                {
                    'categories': ["Prix Italia|Category-d20257b2-b452-4877-9219-b2b4cbb395b8"],
                    'href': "/ufficiostampa/Comunicati-fa34ec44-48fc-47bb-9b33-a816feb74563.html?tematica=Prix%20Italia|Category-d20257b2-b452-4877-9219-b2b4cbb395b8&tipo=Articolo",
                    'label': "Prix Italia"
                }
            },
            {
                'Radio TV e Digital': {
                    'categories': ['Comunicati Radio tv e digital|Category-5992d6fe-2de2-444a-ad8c-2421ec15f2bb'],
                    'href': '/ufficiostampa/Comunicati-fa34ec44-48fc-47bb-9b33-a816feb74563.html?tematica=Comunicati%20Radio%20tv%20e%20digital|Category-5992d6fe-2de2-444a-ad8c-2421ec15f2bb&tipo=Articolo',
                    'label': 'Radio TV e Digital'
                }
            },
            {
                'Rai Informa': {
                    'categories': [
                        'COMUNICATI CDA|Category-01e0d5af-0210-4dac-bdff-3df318cbb4e8',
                        'Comunicati Aziendali|Category-0a9a3c8a-f274-4096-9721-501027395077'
                    ],
                    'href': '/ufficiostampa/Comunicati-fa34ec44-48fc-47bb-9b33-a816feb74563.html?tematica=COMUNICATI%20CDA|Category-01e0d5af-0210-4dac-bdff-3df318cbb4e8&tematica=Comunicati%20Aziendali|Category-0a9a3c8a-f274-4096-9721-501027395077&tipo=Articolo',
                    'label': 'Corporate'
                },
            },
            {
                'Ascolti': {
                    'categories': ['Ascolti|Category-970b416a-8d16-4df0-a666-aeb0c8f31340'],
                    'href': '/ufficiostampa/Comunicati-fa34ec44-48fc-47bb-9b33-a816feb74563.html?tematica=Ascolti|Category-970b416a-8d16-4df0-a666-aeb0c8f31340&tipo=Articolo',
                    'label': 'Ascolti'
                }
            },
            {
                'Radiocorriere TV': {
                    'categories': ['Radiocorriere TV|Category-17f7e543-e819-4601-a072-97bbfbf31757'],
                    'href': '/ufficiostampa/Comunicati-fa34ec44-48fc-47bb-9b33-a816feb74563.html?tematica=Radiocorriere%20TV|Category-17f7e543-e819-4601-a072-97bbfbf31757&tipo=Articolo',
                    'label': 'Radiocorriere TV'

                }
            }
        ],
        'media': [
            {
                'Tutti': {
                    'href': '/ufficiostampa/VideoeFoto-0ed9830e-c106-47c2-a77b-33fba3afbc59.html?tipo=Video&tipo=Foto',
                    'label': 'Tutti'
                }
            },
            {
                'video': {
                    'href': '/ufficiostampa/VideoeFoto-0ed9830e-c106-47c2-a77b-33fba3afbc59.html?tipo=Video',
                    'label': 'Video'
                }
            },
            {
                'foto': {
                    'href': '/ufficiostampa/VideoeFoto-0ed9830e-c106-47c2-a77b-33fba3afbc59.html?tipo=Foto',
                    'label': 'Foto'
                }
            },
            {
                'promo': {
                    'categories': ["Promo e Clip|Category-64d6ed88-4bdb-4d8d-b256-78ebf186070b"],
                    'href': "/ufficiostampa/VideoeFoto-0ed9830e-c106-47c2-a77b-33fba3afbc59.html?tipo=Video&tipo=Foto&tematica=Promo e Clip|Category-64d6ed88-4bdb-4d8d-b256-78ebf186070b",
                    'label': "Promo"
                }
            },
            {
                'interviste': {
                    'categories': ["Interviste|Category-bd9607a7-7655-4e12-a41c-1eef243d7385"],
                    'href': "/ufficiostampa/VideoeFoto-0ed9830e-c106-47c2-a77b-33fba3afbc59.html?tipo=Video&tipo=Foto&tematica=Interviste|Category-bd9607a7-7655-4e12-a41c-1eef243d7385",
                    'label': "Interviste"
                }
            },
            {
                'conferenze': {
                    'categories': ["Conferenze Stampa VideoFoto|Category-c754e9dd-2417-4e16-ae49-bba5c299b3fd"],
                    'href': "/ufficiostampa/VideoeFoto-0ed9830e-c106-47c2-a77b-33fba3afbc59.html?tipo=Video&tipo=Foto&tematica=Conferenze Stampa VideoFoto|Category-c754e9dd-2417-4e16-ae49-bba5c299b3fd",
                    'label': "Conferenze"
                }
            }

        ],
        'ricerca': [
            {
                'Tutti': {
                    'href': '/ufficiostampa/ricerca.html',
                    'label': 'Tutti i risultati'
                },
            },
            {
                'video': {
                    'href': '/ufficiostampa/ricerca.html',
                    'label': 'Video'
                },
            },
            {
                'articolo': {
                    'href': '/ufficiostampa/ricerca.html',
                    'label': 'Articoli'
                },
            },
            {
                'foto': {
                    'href': '/ufficiostampa/ricerca.html',
                    'label': 'Foto'
                }
            }
        ]
    }

};
let value = 0;

